import React from 'react';
import PropTypes from 'prop-types';

import './ButtonThumbnailStyleItem.css';

const ButtonThumbnailStyleItem = ({ sumbnailType, active, onClick }) => (
  <div
    className={`button-thumbnail-style-item__component${active ? ' active': ''}`}
    onClick={onClick}
    role="button"
    tabIndex={-1}
  >
    <div className={`button-wrapper ${sumbnailType}`} />
  </div>
);

ButtonThumbnailStyleItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  sumbnailType: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

ButtonThumbnailStyleItem.defaultProps = {
  active: null,
};

export default ButtonThumbnailStyleItem;
